import {useState} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import { useTheme } from '@mui/material/styles';
import { Grid2 as Grid} from '@mui/material';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import DepositoryTrainingPhoto from '../../../../images/depository_training.png';
import LocalTrainingPhoto from '../../../../images/cityseminars2021.jpg';
import BQTrainingPhoto from '../../../../images/onlinelocalfilers.png';
import CourseViewer from './components/CourseViewer';

const courses = [
  {
    media: `${DepositoryTrainingPhoto}`,
    title: 'Depository Candidates',
    description: 'Designed for candidate committees who file reports with OCPF in the depository system.',
    link: 'https://ocpf.ispring.com/app/embed-player/f9183276-1268-11f1-8fc7-feeb53ce00fa',
    note: ' ATTENTION!! <br>The treasurers of depository committees are required to complete online training through Reporter 7. That same training is available here. If you are the treasurer of a depository committee, please click <a href="https://www.ocpfreporter.us/Account/LogOn" target="_blank">here</a> to log into Reporter 7 to take the training, NOT HERE, to <u>earn credit and receive training certificates</u>. This training is made available here for other members of a campaign.',
  },
  {
    media: `${LocalTrainingPhoto}`,
    title: 'Local Filers',
    description: 'Designed for municipal candidates who file campaign finance reports with local election officials.',
    link: 'https://ocpf.ispring.com/app/embed-player/d7cd0324-fb9b-11ef-aac4-8e8606101ded',
    note: 'Local filers include any candidate who files with their local election officials, usually the city or town clerk.',
  },
  {
    media: `${BQTrainingPhoto}`,
    title: 'Municipal Ballot Question Committees',
    description: 'This training discussess  how to organize and operate a municipal ballot question committee.',
    link: 'https://ocpf.ispring.com/app/embed-player/2e7ee5ea-3c8b-11f0-b9ca-4aef3437069c',
    note: '',
  },
];

const TrainingCourses = (): JSX.Element => {
  const theme = useTheme();
  
  const [isCourseViewerOpen, setCourseViewerOpen] = useState(false);
  const [courseTitle, setCourseTitle] = useState('');
  const [courseLink, setCourseLink] = useState('');
  const [courseNote, setCourseNote] = useState('');


  const openCourseViewer = (title: string, link: string, note: string) => {
    setCourseViewerOpen(true);
    setCourseTitle(title);
    setCourseLink(link);
    setCourseNote(note);
  };

  const closeCourseViewer = () => {
    setCourseViewerOpen(false);
    setCourseTitle('');
    setCourseLink('');
  };

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          variant="h4"
          align={'center'}
          data-aos={'fade-up'}
          gutterBottom
          fontWeight={700}
        >
          Popular Campaign Finance Training
        </Typography>
        <Typography
          variant="h5"
          align={'center'}
          color={'text.secondary'}
          data-aos={'fade-up'}
        >
          Online trainings designed for candidates and treasurers of committees
        </Typography>
      </Box>
      <Grid container>
        {courses.map((item, index) => (
            <Grid key={index} size={{xs:12, md:4}}>
            <Box width={1} height={1} padding={{ xs: 1, md: 2, lg: 3 }}>
              <Box
                width={1}
                height={1}
                sx={{
                  textDecoration: 'none',
                  transition: 'all .2s ease-in-out',
                  '&:hover': {
                    transform: `translateY(-${theme.spacing(1 / 2)})`,
                  },
                }}
              >
                <Box
                  component={Card}
                  width={1}
                  height={1}
                  display={'block'}
                  flexDirection={'column'}
                  sx={{ backgroundImage: 'none'}}
                >
                  <CardMedia
                    role="presentation" 
                    title={item.title}
                    image={item.media}
                    sx={{
                      position: 'relative',
                      height: { xs: 240, sm: 340, md: 350 },
                      overflow: 'hidden',
                    }}
                  >
                    <Box
                      component={'svg'}
                      preserveAspectRatio="none"
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      viewBox="0 0 1921 273"
                      sx={{
                        position: 'absolute',
                        width: '100%',
                        left: 0,
                        bottom: 0,
                        right: 0,
                        zIndex: 1,
                      }}
                    >
                      <polygon
                        fill={theme.palette.background.paper}
                        points="0,273 1921,273 1921,0 "
                      />
                    </Box>
                    <Box
                      display={'flex'}
                      justifyContent={'space-between'}
                      position={'absolute'}
                      bottom={0}
                      padding={1}
                      width={1}
                      zIndex={2}
                    >
                      <Button
                        variant={'contained'}
                        color="primary"
                        size="large"
                        startIcon={<PlayCircleOutlineIcon/>}
                        onClick={()=>openCourseViewer(item.title, item.link, item.note)}
                      >
                        Watch
                      </Button>
                    </Box>
                  </CardMedia>
                  <CardContent>
                    <Typography
                      variant={'h6'}
                      gutterBottom
                      align={'left'}
                      sx={{ fontWeight: 700 }}
                    >
                      {item.title}
                    </Typography>
                    <Typography
                        variant={'subtitle2'}
                        gutterBottom
                        align={'left'}
                        marginTop={2}
                      >
                      {item.description}
                      </Typography>
                  </CardContent>
                </Box>
              </Box>
            </Box>
            </Grid>
          ))}
      </Grid>
      <CourseViewer isCourseViewerOpen={isCourseViewerOpen} closeCourseViewer={closeCourseViewer} courseTitle={courseTitle} courseLink={courseLink} courseNote={courseNote}></CourseViewer>
    </Box>
  );
};

export default TrainingCourses;
